import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { getClients } from '../../../reducers/clients';

import { FormattedMessage } from 'react-intl';
import { CheckboxField, PhoneField, SelectField, TextField } from '../../fields';
import { required, email, none } from '../../../utilities/validation';
import messages from '../../../text/messages';
import { RoleDefinitions } from '../../../utilities/roles';
import WizardButtons from '../../wizard/navigator/buttons';

class InviteForm extends React.Component {
    constructor(props) {
        super(props);

        this.renderAdditionalFields = this.renderAdditionalFields.bind(this);
        this.userFields = this.userFields.bind(this);
        this.clientFields = this.clientFields.bind(this);
    }

    componentDidMount() {
        const { role, getClients, clients, tenantType } = this.props;
        if (tenantType === 'admin' && clients.length === 0) {
            getClients(role.id, 'current', undefined, true);
        }
    }

    renderAdditionalFields(isNewClient) {
        const { selectedRole, selectedAdminHrs, admins, clients } = this.props;
        if (!selectedRole) {
            return null;
        }

        let isAdminSelected = admin => {
            if (!selectedAdminHrs) {
                return false;
            }

            for (const key in selectedAdminHrs) {
                if (selectedAdminHrs.hasOwnProperty(key) && key === admin.id && selectedAdminHrs[key] === true) {
                    return true;
                }
            }

            return false;
        };

        if (isNewClient) {
            return (
                <div className="row">
                    <div className="col-xs-12">
                        <div>
                            <FormattedMessage id={'assignGlHrs'} defaultMessage={'Assign success rep(s)'} />
                        </div>
                        {admins &&
                            admins.map((admin, i) => (
                                <Field
                                    key={i}
                                    name={`glHr.${admin.id}`}
                                    component={CheckboxField}
                                    checked={isAdminSelected(admin)}
                                    placeholder={`${admin.first_name} ${admin.last_name}`}
                                    hideErrors
                                />
                            ))}
                    </div>
                </div>
            );
        }

        switch (selectedRole) {
            case RoleDefinitions.Client.type:
            case RoleDefinitions.ClientHiringManager.type:
            case RoleDefinitions.ClientTimesheetApprover.type:
            case RoleDefinitions.ClientAPI.type:
            case RoleDefinitions.Contractor.type:
                let options = clients.map(client => ({ value: client.id, label: client.name }));
                let sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
                return (
                    <div className="row section">
                        <div className="col-xs-12">
                            <Field name="clientId" component={SelectField} validate={required} options={sortedOptions} placeholder={messages.chooseClient} />
                        </div>
                    </div>
                );

            default:
                return null;
        }
    }

    userFields() {
        return (
            <div>
                <div className="col-xs-6">
                    <Field name="first_name" component={TextField} validate={required} placeholder={messages.firstName} />
                </div>
                <div className="col-xs-6">
                    <Field name="last_name" component={TextField} validate={required} placeholder={messages.lastName} />
                </div>
                <div className="col-xs-12">
                    <Field name="email" component={TextField} validate={[required, email]} placeholder={messages.email} />
                </div>
                <div className="col-xs-12">
                    <Field name="phone" component={PhoneField} placeholder={messages.phoneNumber} />
                </div>
            </div>
        );
    }

    clientFields() {
        const { isNewClient } = this.props;
        return (
            <div className="col-xs-12">
                <Field
                    name="company_name"
                    component={TextField}
                    validate={isNewClient ? required : none}
                    placeholder={isNewClient ? messages.companyRequired : messages.companyIfApplicable}
                />
            </div>
        );
    }

    render() {
        const { handleSubmit, submitting, cancel, tenantType, availableRoles, initialValues, isNewClient, clientId } = this.props;
        const roleOptions = availableRoles.map(r => ({ label: r.label, value: r.type }));
        if (roleOptions.length === 1) {
            initialValues.role = roleOptions[0].value;
        }
        initialValues.clientId = clientId;
        const isAdmin = tenantType === 'admin';
        const submitMessage =
            initialValues && initialValues.id !== undefined ? (
                <FormattedMessage id={'updateInvite'} defaultMessage={'Update invite'} />
            ) : (
                <FormattedMessage id={'sendInvite'} defaultMessage={'Send invite'} />
            );
        return (
            <form onSubmit={handleSubmit}>
                {isNewClient && this.clientFields()}
                {this.userFields()}
                <div className="col-xs-12">
                    <Field
                        name="role"
                        component={SelectField}
                        options={roleOptions}
                        disabled={roleOptions.length === 1}
                        validate={required}
                        placeholder={messages.role}
                    />
                </div>
                <div className="col-xs-12">{isAdmin && this.renderAdditionalFields(isNewClient)}</div>
                <div className="col-xs-12">
                    <WizardButtons disabled={submitting} cancel={{ action: cancel }} submit={{ message: submitMessage }} />
                </div>
            </form>
        );
    }
}

InviteForm.defaultProps = {
    handleSubmit: undefined,
    admins: undefined,
    clients: [],
    tenantType: 'admin',
    isNewClient: false,
    clientId: undefined
};
InviteForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    admins: PropTypes.array,
    clients: PropTypes.array,
    tenantType: PropTypes.string,
    isNewClient: PropTypes.bool,
    clientId: PropTypes.string
};

const mapStateToProps = state => {
    const selector = formValueSelector('invite-form');
    return {
        selectedRole: selector(state, 'role'),
        selectedAdminHrs: selector(state, 'glHr'),
        role: state.identity.role,
        clients: state.clients.list
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClients: getClients
        },
        dispatch
    );

InviteForm = reduxForm({
    form: 'invite-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(InviteForm);

export default connect(mapStateToProps, mapDispatchToProps)(InviteForm);



// WEBPACK FOOTER //
// ./src/components/forms/invite/index.jsx